import { useContext } from 'react'
import { FestivalContextValue } from './FestivalContextValue'

export const useFestival = () => useContext(FestivalContextValue)
